@if (isServer && (showMobileHeader || headerState.isMainPage || !isMobile)) {
    <app-header-loader></app-header-loader>
}
@if (!isServer) {
    @if (show_smart_banner && isBrowser) {
        <app-smart-banner (closeDialog)="closeSmartBanner()"></app-smart-banner>
    }
    <header #headerElement>
        @if (showMobileHeader) {
            <div class="mobile-nav-header">
                <button id="backbutton" (click)="goBack()">
                    <mat-icon aria-hidden="true" style="color: var(--primary-text-color)">arrow_back</mat-icon>
                </button>
                <div class="mobile-header-text">
                    <div>
                        <span class="navbar-brand-text">
                            {{ headerState.currentUrl }}

                            @if (headerState.isCartPage && cartCount) {
                                <span> ({{ cartCount }} {{ cartCount === 1 ? 'Item' : 'Items' }}) </span>
                            }
                        </span>
                    </div>
                    <span style="display: flex; align-items: center">
                        @if (headerState.isMenuPage) {
                            <span routerLink="/search" style="display: flex; align-items: center; margin-right: 16px">
                                <svg
                                    width="24px"
                                    height="20px"
                                    viewBox="0 0 16 16"
                                    class="bi bi-search"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        fill-rule="evenodd"
                                        d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z" />
                                    <path
                                        fill-rule="evenodd"
                                        d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z" />
                                </svg>
                            </span>
                            <div style="display: flex">
                                <label class="veg-toggle-wrapper">
                                    <input type="checkbox" [(ngModel)]="is_veg" (click)="toggleOnlyVeg()" />
                                    <span class="veg-toggle">Veg</span>
                                </label>
                            </div>
                        }
                    </span>
                </div>
            </div>
        }
        @if (!isMobile) {
            <div
                class="header-row"
                [ngStyle]="{ 'background-color': backgroundColor, color: textColor, 'box-shadow': boxShadow }">
                <div class="header-left">
                    <div class="hidden-xs">
                        <a routerLink="/" class="brand-logo">
                            <img src="{{ DEPLOY_URL }}/assets/images/logo.png" alt="brand-logo" />
                        </a>
                    </div>
                    <div class="search-box-wrapper" data-test="search-box-wrapper">
                        @if (!headerState.showSearchBox) {
                            <ng-template *ngTemplateOutlet="desktopLocation"></ng-template>
                        } @else {
                            <ng-template *ngTemplateOutlet="showSearchBox"></ng-template>
                        }
                    </div>
                </div>
                <!-- Desktop Header Links -->
                <div class="header-right">
                    <ul class="navbar-actions" [hidden]="headerState.isCartPage">
                        <li>
                            <div class="favourite-wrapper" role="button" tabindex="0" (click)="navigateTo('/membership')">
                                <span class="headerlink" [class.active]="headerState.isBrandingPage">
                                    <span class="headerlink__text"> Why EatClub? </span>
                                </span>
                            </div>
                        </li>
                        <li>
                            <span
                                #appOfferButton
                                [matMenuTriggerFor]="appOffer"
                                class="header-customer"
                                #appOfferState="matMenuTrigger"
                                role="button"
                                tabindex="0"
                                [class.active]="appOfferState.menuOpen"
                                data-test="deals">
                                <span class="headerlink">
                                    <span class="headerlink__icon headerlink__icon--offer"></span>
                                    <span class="headerlink__text">Deals</span>
                                    @if (!appOfferState.menuOpen) {
                                        <mat-icon>expand_more</mat-icon>
                                    } @else {
                                        <mat-icon>expand_less</mat-icon>
                                    }
                                </span>
                            </span>
                            <mat-menu
                                #appOffer="matMenu"
                                class="mat-menu-dropdown header-menu-dropdown"
                                role="button"
                                tabindex="0">
                                <a mat-menu-item routerLink="/refer" role="button" tabindex="0"> Refer & Earn </a>
                                <a mat-menu-item routerLink="/party_order" role="button" tabindex="0"> Bulk Order </a>
                                <a mat-menu-item routerLink="/offers" data-test="offer-page" role="button" tabindex="0">
                                    Offers
                                </a>
                            </mat-menu>
                        </li>
                        <li [hidden]="!showCartDropDown" #cartRef role="button" tabindex="0">
                            <app-cart-dropdown [showCartDropDown]="showCartDropDown"></app-cart-dropdown>
                        </li>
                        @if (isEatclub) {
                            <li>
                                <a role="button" tabindex="0" (click)="scrollToDownloadBanner()">
                                    <span class="get-the-app center">
                                        Get the app
                                        <img src="{{ DEPLOY_URL }}/assets/images/redirect.svg" alt="download app" />
                                    </span>
                                </a>
                            </li>
                        }
                        @if (is_logged_in && creditBal) {
                            <li>
                                <a role="button" tabindex="0" (click)="navigateTo('/credits')">
                                    <span class="headerlink" [class.active]="headerState.isCreditsPage">
                                        <img
                                            src="{{ DEPLOY_URL }}/assets/images/credit-coin.png"
                                            class="credit-coin"
                                            alt="credits" />
                                        <span class="headerlink__text" style="text-transform: none; max-width: max-content"
                                            >{{ creditBal }} Credits</span
                                        >
                                    </span>
                                </a>
                            </li>
                        }
                        <!-- Desktop Profile Dropdown Option -->
                        <li>
                            @if (!is_logged_in) {
                                <a
                                    href="JavaScript:void(0);"
                                    data-test="login-btn"
                                    role="button"
                                    tabindex="0"
                                    (click)="showSignInModal()">
                                    <div class="center sign-in-cta">Sign in</div>
                                </a>
                            } @else {
                                <span>
                                    <span
                                        #appMenuButton
                                        [matMenuTriggerFor]="appMenu"
                                        class="header-customer"
                                        #appMenuState="matMenuTrigger"
                                        role="button"
                                        tabindex="0"
                                        [class.active]="appMenuState.menuOpen">
                                        <span class="headerlink">
                                            <span class="headerlink__icon headerlink__icon--profile"></span>
                                            <span class="headerlink__text">{{ customerName }}</span>
                                            @if (!appMenuState.menuOpen) {
                                                <mat-icon>expand_more</mat-icon>
                                            } @else {
                                                <mat-icon>expand_less</mat-icon>
                                            }
                                        </span>
                                    </span>
                                    <mat-menu #appMenu="matMenu" class="mat-menu-dropdown header-menu-dropdown">
                                        <a mat-menu-item routerLink="/profile" role="button" tabindex="0"> My Profile </a>
                                        <a mat-menu-item routerLink="/manage_orders" role="button" tabindex="0">
                                            Manage Orders
                                        </a>
                                        <a mat-menu-item (click)="navigateTo('/refer')" role="button" tabindex="0">
                                            Refer & Earn
                                        </a>
                                        <a mat-menu-item (click)="navigateTo('/credits')" role="button" tabindex="0"> Credits </a>
                                        <a mat-menu-item (click)="logOut()" role="button" tabindex="0"> Sign Out </a>
                                    </mat-menu>
                                </span>
                            }
                        </li>
                    </ul>
                </div>
            </div>
        }
        @if (headerState.isMainPage && isMobile) {
            <div
                class="header-row"
                [ngStyle]="{ 'background-color': backgroundColor, color: textColor, 'box-shadow': boxShadow }">
                <div class="header-left">
                    <div class="search-box-wrapper" data-test="search-box-wrapper">
                        @if (!headerState.showSearchBox) {
                            <ng-template [ngTemplateOutlet]="mobileLocation"></ng-template>
                        } @else {
                            <ng-template [ngTemplateOutlet]="showSearchBox"></ng-template>
                        }
                    </div>
                </div>
            </div>
        }
    </header>
    <div class="header-spacing" #headerSpacing></div>
}
<ng-template #mobileLocation>
    <div class="mobile-search-box">
        <div class="location-body" role="button" tabindex="0" (click)="editLocality()">
            <div class="static-text" [ngStyle]="{ color: textColor }">
                <b style="font-size: 12px">{{ outletLocality['address_type'] }}</b>
                @if (outletLocality['address_type'] === 'Delivery' && headerNotification['psla']) {
                    <b style="font-size: 12px">in</b>
                    <b style="font-size: 18px">{{ headerNotification['psla'] }}</b>
                }
            </div>
            <div class="selected-location">
                <div class="mask">
                    <div class="location-img" [ngStyle]="{ 'background-color': textColor }"></div>
                </div>
                <div class="current-location">
                    @if (outletLocality['address_name']) {
                        {{ outletLocality['address_name'] }} -
                    }
                    {{ outletLocality['locality'] }}
                </div>
                <a class="edit-btn">
                    <mat-icon style="font-size: 18px; height: 18px">expand_more</mat-icon>
                </a>
            </div>
        </div>
        @if (is_logged_in && creditBal) {
            <div class="center">
                <div
                    role="button"
                    tabindex="0"
                    class="credits"
                    [ngStyle]="{ 'border-color': textColor, color: textColor }"
                    (click)="navigateTo('/credits')">
                    <img src="{{ DEPLOY_URL }}/assets/images/credit-coin.png" class="credit-coin" alt="credits" />
                    <div class="credit-coin-right">
                        <span class="credits-bal">{{ creditBal }}</span>
                        <span class="credits-text">
                            {{ creditBal > 1 ? 'credits' : 'credit' }}
                        </span>
                    </div>
                </div>
            </div>
        }
    </div>
    @if (showLocationChange) {
        <app-popover (isCtaClicked)="updateLocation(position)" (isDismissed)="hideUpdateLocation()"></app-popover>
    }
</ng-template>
<ng-template #desktopLocation>
    <div class="text-center">
        <div
            class="search-box"
            role="button"
            tabindex="0"
            (click)="editLocality()"
            [class.disabled]="!headerState.showEditButton">
            <div class="current-location-text">
                <b style="text-transform: uppercase">{{ outletLocality['address_type'] }}</b>
                <span style="margin-left: 10px">{{ outletLocality['locality'] }}</span>
            </div>
            <a class="edit-btn" [hidden]="!headerState.showEditButton">
                <mat-icon>expand_more</mat-icon>
            </a>
        </div>
        @if (showLocationChange) {
            <app-popover (isCtaClicked)="updateLocation(position)" (isDismissed)="hideUpdateLocation()"></app-popover>
        }
    </div>
</ng-template>
<ng-template #showSearchBox>
    <div class="input-box text_search-box">
        <div class="search-container">
            <span class="addressSVG loc-icon">
                <span class="addressSVG__icon addressSVG__icon--location"></span>
            </span>
            <input
                type="text"
                class="google-place-input full-width input-search"
                appGooglePlace
                [isHeader]="true"
                [mode]="'header'"
                (onSelect)="selectAddress($event)"
                [(ngModel)]="placeSearch"
                data-test="google-place-input"
                autocomplete="off"
                placeholder="Enter Delivery Location" />
            <div class="cross-icon" role="button" tabindex="0" (click)="hideSearchBox()">&#10005;</div>
        </div>
        @if (!placeSearch || placeSearch?.length === 0) {
            <div class="suggested-location">
                @if (locationChangeInfo.show) {
                    <div class="location-change-warn">
                        {{ locationChangeInfo.message }}
                    </div>
                }
                <div class="saved-address-text" style="text-transform: none; font-style: italic; font-weight: normal">
                    We need your delivery location to serve you a delicious meal.
                </div>
                <ul class="use-current-location" (click)="autoDetectLocation()">
                    @if (!locating) {
                        <img src="{{ DEPLOY_URL }}/assets/images/locate-me.svg" width="20" alt="locate-me" />
                    } @else {
                        <img src="{{ DEPLOY_URL }}/assets/images/location-spinner.svg" width="20" alt="locate-me" />
                    }
                    &nbsp;
                    <span style="font-weight: 600">Use my current location</span>
                </ul>
                @if (addresses?.length > 0) {
                    <div class="saved-address-text">Saved Address</div>
                    <ul>
                        @for (address of addresses | slice: 0 : 5; track address) {
                            <li role="button" tabindex="0" (click)="selectSavedAddress(address)">
                                <app-sprite-icons [iconType]="address.address_type" [enabled]="true"> </app-sprite-icons>
                                <div class="text-container">
                                    <span class="matched_text">
                                        {{ address.address_custom_name || address.address_type || 'Others' }}
                                    </span>
                                    <span class="secondary_text">
                                        {{ address.address_line }}
                                    </span>
                                </div>
                            </li>
                        }
                    </ul>
                }
            </div>
        }
    </div>
</ng-template>
